"use strict";
// Taken from Angular's version.ts file.
// See: https://github.com/angular/angular/blob/16.2.x/packages/core/src/version.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.Version = void 0;
/**
 * @internal
 */
class Version {
    constructor(full) {
        this.full = full;
        this.major = full.split('.')[0];
        this.minor = full.split('.')[1];
        this.patch = full.split('.').slice(2).join('.');
    }
}
exports.Version = Version;
/**
 * Represents the version of @skyux/icons.
 */
exports.VERSION = new Version('7.24.0');
